import React from 'react';
import { TipsMapType } from '../index';

export const topicTipsMentionsText: TipsMapType = {
  en: (
    <>
      Because one review may have multiple topics, the total reviews has been
      remove duplicates here.
      <br />
      The topic mentions proportion is obtained by dividing the number of
      reviews on the topic by the number of total reviews(after removing
      duplicates).
    </>
  ),
  zh: (
    <>
      由于一条评论可能命中多个话题，此处话题的【总评论数】已进行去重处理。
      <br />
      话题声量占比是由【该话题的评论数】除以【去重后的总评论数】获得。
    </>
  ),
};
